import React from "react";
import { connect } from "react-redux";
import { Field } from "redux-form";
import { renderField, renderRadioField } from "../../../../../utils/renderField";
import {
  required,
  number,
  fieldLength9,
  alphanumericAndHyphen,
  checkHyphens,
  maxLength17,
  accountNumberMatch,
} from "../../../../../utils/formValidators";
import { AchInstitutionDisplay } from "../../../../ach-institution-display/ach-institutiton-display.component";
import Show from "../../../../../utils/show.component";
import {
  searchForInstitution,
  clearAchInstitution,
} from "../../../../../actions/achInstitution.actions";
import StylizedRadioGroup from "../../../misc/stylized-radio-group.component";

const AuthAchFieldsComponent = (props) => {
  const showAchDisplay = () => {
    return props.thisForm && props.thisForm.values;
  };

  const onRoutingNumberChange = (e) => {
    if (e.target.value.length === 9) {
      props.searchForInstitution(e.target.value);
    } else {
      props.clearAchInstitution();
    }
  };

  return (
    <div>
      <div className="py-4 bold f18">Bank Account Information</div>
      <div className="row mb-3">
        <div className="col px-3">
          <StylizedRadioGroup
            radioOptions={[{ label: "Checking", id: "checking", value: "true" }]}
            fieldGroupName="isChecking"
            thisForm={props.thisForm}
            change={props.change}
          />
        </div>
        <div className="col px-3">
          <StylizedRadioGroup
            radioOptions={[{ label: "Savings", id: "savings", value: "false" }]}
            fieldGroupName="isChecking"
            thisForm={props.thisForm}
            change={props.change}
          />
        </div>
      </div>
      <div className="mb-3">
        <Field
          label="Name on Bank Account"
          name="NameOnAccount"
          component={renderField}
          validate={[required]}
          type="text"
        />
      </div>
      <div className="mb-3">
        <Field
          component={renderField}
          label="Routing Number"
          name="RoutingNumber"
          // tooltip={routingNumberToolTip}
          validate={[required, number, fieldLength9]}
          onKeyUp={(e) => onRoutingNumberChange(e)}
          maxLength={9}
          type="text"
          inputMode="numeric"
          e2eId="routingNumber"
        />
        <Show condition={showAchDisplay()}>
          <AchInstitutionDisplay achInstitutionState={props.achInstitution} showIcons={false} />
        </Show>
      </div>
      <div className="mb-3">
        <Field
          component={renderField}
          label="Account Number"
          name="AccountNumber"
          validate={[required, alphanumericAndHyphen, checkHyphens, maxLength17]}
          type="text"
          e2eId="accountNumber"
        />
      </div>
      <div className="mb-3">
        <Field
          component={renderField}
          label="Re-enter Account Number"
          name="AccountNumberVerification"
          validate={[
            required,
            alphanumericAndHyphen,
            checkHyphens,
            maxLength17,
            accountNumberMatch,
          ]}
          type="text"
          e2eId="secondAccountNumber"
        />
        <div className="col-6"></div>
      </div>
    </div>
  );
};

const mapDispatchToProps = {
  searchForInstitution,
  clearAchInstitution,
};

const AuthAchFields = connect(null, mapDispatchToProps)(AuthAchFieldsComponent);

export default AuthAchFields;



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/payment-forms/field-components/general/auth-ach-fields.component.js